import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  ViewChild,
} from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-list-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatMenuModule],
  host: {
    'role': 'option',
    '[attr.data-selected]': 'selected()',
    '[attr.aria-selected]': 'selected()',
    '[attr.data-selectable]': 'selectable()',
    '[attr.data-checked]': 'checked()',
    '[tabindex]': '0',
    '(contextmenu)': 'onRightClick($event)',
  },
  template: `
    @if (selectable()) {
      <span
        class="list-item__check"
        [class.list-item__check--on]="checked()"
        (click)="onCheckToggle($event)"
      >
        <span class="material-icons list-item__check-icon" translate="no">
          {{ checked() ? 'check_circle' : 'radio_button_unchecked' }}
        </span>
      </span>
    }
    <ng-content select="[itemIcon]" />
    <span class="list-item__title">
      <ng-content select="[itemTitle]" />
    </span>
    <span class="list-item__suffix">
      <ng-content select="[itemSuffix]" />
    </span>

    @if (hasMenu()) {
      <button
        type="button"
        class="list-item__menu-hint"
        [matMenuTriggerFor]="contextMenu"
        aria-label="Open item actions"
        (click)="$event.stopPropagation()"
      >
        <span class="material-icons" translate="no" aria-hidden="true">more_horiz</span>
      </button>
    }
    <mat-menu #contextMenu="matMenu" (click)="closeMenu()">
      <ng-content select="[itemMenu]" />
    </mat-menu>
  `,
  styleUrl: './list-item.component.scss',
})
export class ListItemComponent {
  selected = input(false);
  selectable = input(false);
  hasMenu = input(false);
  checked = model(false);

  @ViewChild(MatMenuTrigger) private menuTrigger!: MatMenuTrigger;

  onCheckToggle(event: MouseEvent): void {
    event.stopPropagation();
    this.checked.update(v => !v);
  }

  onRightClick(event: MouseEvent): void {
    if (!this.hasMenu()) {
      return;
    }
    event.preventDefault();
    if (this.menuTrigger) {
      this.menuTrigger.openMenu();
    }
  }

  closeMenu(): void {
    this.menuTrigger?.closeMenu();
  }
}
